// src/pages/admin/AdminOverviewPage.tsx
import React from 'react';

const AdminOverviewPage: React.FC = () => {
  // TODO: 시스템 전체 통계 API 붙이기
  return (
    <div className="p-4 space-y-6">
      <h1 className="text-xl font-bold text-gray-900">Super Admin Overview</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="rounded-xl border bg-white p-4 shadow-sm">
          <div className="text-xs text-gray-500 mb-1">총 회사 수</div>
          <div className="text-2xl font-semibold text-sky-800">-</div>
        </div>
        <div className="rounded-xl border bg-white p-4 shadow-sm">
          <div className="text-xs text-gray-500 mb-1">총 프로젝트 수</div>
          <div className="text-2xl font-semibold text-sky-800">-</div>
        </div>
        <div className="rounded-xl border bg-white p-4 shadow-sm">
          <div className="text-xs text-gray-500 mb-1">총 사용자 수</div>
          <div className="text-2xl font-semibold text-sky-800">-</div>
        </div>
      </div>

      <div className="rounded-xl border bg-white p-4 shadow-sm">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-sm font-semibold text-gray-800">최근 생성된 Company</h2>
          <button className="text-xs text-sky-700 hover:underline">전체 보기</button>
        </div>
        <div className="text-sm text-gray-500">
          {/* TODO: 최근 Company 리스트 */}
          아직 Company 데이터가 없습니다.
        </div>
      </div>
    </div>
  );
};

export default AdminOverviewPage;
